
import * as types from "../actions/types/index";
import {setInitialState} from "../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.CHARGE_VIEWER_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.CHARGE_VIEWER_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                isError: false,
                payload: action.payload
            };
        case types.CHARGE_VIEWER_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                isSuccess: false,
                payload: action.payload.response.error,
            };
        case types.RESET_CHARGE_VIEWER:
            return {
                ...state,
                payload: action.payload,
            };
        default:
            return {
                ...state
            }
    }
}